module.exports = __webpack_public_path__ + "img/Ashley Mendez.05b1919e.jpg";